import { useContext, useEffect, useRef, useState } from "react";
import { Badge, Card } from "flowbite-react";
import { CustomModal } from "../../layouts/customModal";
import CampaignForm from "./campaignForm";
import { FILTERS } from "../../helpers/creditBonus/helper";
import CampaignDetail from "./detailsPanel";
import { getCampaigns } from "../../services/creditBonus/creditBonusActions";
import { usePaginate } from "../../hooks/usePaginate";
import CampaignCard from "./campaignCard";
import { StatusContext } from "../../context/statusProvider";
import { ResponseContext } from "../../context/responseProvider";

const CampaignSection = () => {
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);
  const modalRef = useRef(null);
  const openRef = useRef(null);
  const [campaign, setAllCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { showingItems, PaginateBtn } = usePaginate(campaign, null);
  const { updateAPI, handleApi } = useContext(StatusContext);
  const { getResponse } = useContext(ResponseContext);

  const filtered =
    filter === "all" ? campaign : campaign.filter((c) => c.status === filter);
  /* 
  useEffect(() => {
    getCampaigns({ setIsLoading }).then((res) => {
      setAllCampaigns(res);
    });
  }, [updateAPI]); */

  useEffect(() => {
    getCampaigns({ setIsLoading }).then((res) => {
      setAllCampaigns(res);

      // sync selected with fresh data after refetch
      setSelected((prev) =>
        prev ? (res.find((c) => c.id === prev.id) ?? prev) : null,
      );
    });
  }, [updateAPI]);

  return (
    <div className="container">
      <div className="max-w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-16 sm:flex sm:items-top sm:justify-center">
        <div className="grid gap-4 grid-cols-1 lg:grid-cols-2 w-full">
          <div className="w-full">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-3xl font-bold tracking-tight text-secondary">
                Campaigns
              </h2>
              {getResponse("create_campaign")?.status === true && (
                <Badge color="success">Campaign created successfully!</Badge>
              )}
            </div>

            <div className="flex justify-between ">
              <div className="flex gap-1.5 mb-3">
                {FILTERS.map((f) => (
                  <button
                    key={f}
                    onClick={() => setFilter(f)}
                    className={`px-3 py-1 rounded-full text-xs font-medium capitalize transition-colors
                ${
                  filter === f
                    ? "bg-primary text-white"
                    : "bg-gray-100 text-gray-500 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                }`}
                  >
                    {f}
                  </button>
                ))}
              </div>
              <CustomModal
                btnText="+ New campaign"
                modalRef={modalRef}
                openRef={openRef}
                isIndex={true}
                closeOnOutsideClick={true}
              >
                <div className="w-full sm:w-[860px]">
                  <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4">
                    New campaign
                  </h3>
                  <CampaignForm modalRef={modalRef} handleApi={handleApi} />
                </div>
              </CustomModal>
            </div>

            {/* Campaign list */}
            <CampaignCard
              data={filtered}
              isLoading={isLoading}
              selected={selected}
              setSelected={setSelected}
              showingItems={showingItems}
            />

            <div className="flex justify-center">
              <PaginateBtn />
            </div>
          </div>

          {/* ── detail panel ── */}
          <div className="w-full">
            <h2 className="text-3xl font-bold tracking-tight text-secondary mb-4">
              Campaign details{" "}
            </h2>
            <div className="flex items-start gap-2 mb-3 rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm text-yellow-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mt-0.5 h-4 w-4 shrink-0"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                  clipRule="evenodd"
                />
              </svg>
              <span>
                All new campaigns are <strong>inactive by default</strong> and
                must be reviewed and activated by the development team.
              </span>
            </div>

            <Card className="min-h-[400px]">
              {selected ? (
                <CampaignDetail
                  campaign={selected}
                  onClose={() => setSelected(null)}
                  handleApi={handleApi}
                />
              ) : (
                <div className="flex flex-col items-center justify-center h-64 text-gray-300 dark:text-gray-600">
                  <svg
                    className="w-12 h-12 mb-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                  <p className="text-sm">Select a campaign to view details</p>
                </div>
              )}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignSection;
